/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="addOnGroup.module.ts" />

module Meevo.Plugins.AddOnGroup {

    class AddOnGroupController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {

        public displayNameColumn = { header: "Display Name", fieldName: 'DisplayName', sortDirection: Model.SortDirection.Ascending, width: 20 };
        public coColumnsSet = [
            { header: "Home Location", fieldName: 'HomeLocation', sortDirection: null, width: 35 },
            { header: "Business Type", fieldName: 'BusinessType', sortDirection: null, width: 35 },
            { header: "Exists At", fieldName: 'TotalLocations, AvailableAtLocations', sortDirection: null, width: 30 }
        ];

        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',

            "meevo.components.busy.BusyService",
            "$translate",
            "$q"
        ];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected dataService: Meevo.Components.BaseClasses.IDataService,
                    protected modalService: Meevo.Components.Modal.IModalService,
                    protected identityService: Meevo.Components.Common.IIdentityService,
                    protected loggingService: Meevo.Components.Logging.ILoggingService,
                    protected securityService: Meevo.Components.Common.ISecurityService,
                    protected trackingService: Meevo.Components.Tracking.ITrackingService,
                    protected $rootScope: angular.IRootScopeService,
                    protected $scope: angular.IScope,
                    protected $state: any,
                    protected contextParams: any,
                    protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,

                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected $translate: angular.translate.ITranslateService,
                    protected $q: angular.IQService) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);
        }

        /**
         * Creates the context for editing/adding an item.
         * @return {}
         */
        createContext(): void {
            this.busyService.start();

            this.securityService.checkSection(this.meevoSecurityKeys.DATA_ADDONGROUP).then(() => {
                this.busyService.stop();
                this.context = new AddOnGroupContext(
                    this.appSettings,
                    this.dataService,
                    this.modalService,
                    this.identityService,
                    this.loggingService,
                    this.securityService,
                    this.trackingService,
                    this.busyService,
                    this.$q);

                super.createContext();

                this.context.activate(this.selectedItemId, null, this.asLocationId);

                this.context.deactivate = () => {
                    this.visualState = Model.MaintenanceFormVisualState.Search;
                };
            });

        }
    }

    angular.module('meevo.plugins.addOnGroup')
        .controller('meevo.plugins.addOnGroup.AddOnGroupController', AddOnGroupController);
}